import React from 'react';
import { createStyles, makeStyles, Grid, Divider } from '@material-ui/core';
import LogoJp from './images/tabicube_ja.jpg';
import LogoEn from './images/tabicube_en.jpg';
import { useTranslation } from 'react-i18next';
import { changeLang } from '../../../../../../states/query';
import { isJapanese } from '../../../../../../utils/lang';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      padding: 0,
    },
  }),
);

/** 旅CUBE用のハイヤー・タクシー予約画面用のヘッダー。 */
const TabiCube: React.FC = () => {
  const classes = useStyles({});
  const { i18n } = useTranslation();
  const lang = changeLang(i18n.language);
  const alt = isJapanese(lang) ? '旅CUBE ハイヤー・タクシー予約 ロゴ': 'Travel CUBE Hire/taxi Reservation Logo';
  const logo = isJapanese(lang) ? LogoJp : LogoEn;

  return (
    <div className={classes.root}>
      <Grid container direction='column' alignItems='center'>
        <Grid item>
          <img
            src={logo}
            alt={alt}
            style={{ maxHeight: "80px" }}
          />
        </Grid>
      </Grid>
      <Divider />
    </div>
  )
}

export default TabiCube;
